<template>
  <div class="modal alert_modal" @click="hideAlert">
      <div class="alert_card" @click.stop>
        <div class="alert_title">
            {{titleTxt}}
        </div>
        <div class="alert_body_txt">
              {{bodyTxt}}
        </div>
        <div class="alert_btns">
            <button class="alert_dismiss_btn btn btn-l btn-secondary" @click="cancelClicked" v-if="cancelBtnTxt">{{cancelBtnTxt}}</button>
            <button class="alert_submit_btn btn btn-l btn-primary" @click="submitClicked">{{submitBtnTxt}}</button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'alertModal',
    props: {
        titleTxt: {
            type: String,
            default: "Alert Title"
        },
        bodyTxt: {
            type: String,
            default: "Alert Body Text"
        },
        submitBtnTxt: {
            type: String,
            default: 'Submit'
        },
        cancelBtnTxt: {
            type: String,
            // default: 'Cancel'
        },
    },
    data() {
        return {
        }
    },
    methods: {
        hideAlert() {
            this.$emit('hideAlert');
        },
        toggleBodyScroll() {
            // Stop page from scrolling
            const pageBody = document.body;
            if (pageBody.classList.contains('hideScroll')) {
                pageBody.classList.remove('hideScroll');
            } else {
                pageBody.classList.add('hideScroll');
            }
        },
        submitClicked() {
            this.$emit('submitClicked');
        },
        cancelClicked() {
            this.$emit('cancelClicked');
        },
    },
    mounted() {
        this.toggleBodyScroll();
    },
    destroyed() {
        this.toggleBodyScroll();
    },
}
</script>

<style>

</style>